<template>
  <div>
    <a-modal
      v-model="visible"
      title="Edit Academic Term"
      :afterClose="handleAfterClose"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">
          Update Term
        </a-button>
      </template>

      <a-form class="mb-4 row" :form="form">
        <a-form-item label="Academic Term" class="col-md-6">
          <a-input
            v-decorator="[
              'name',
              {rules: [{ required: true, message: 'Please input the term name' }]},
            ]"
            placeholder="e.g. First Term, Second Term, Third Term"
          />
        </a-form-item>
        <a-form-item label="Session" class="col-md-6">
          <a-select
            v-decorator="[
              'session_id',
              {rules: [{ required: true, message: 'Please select a session' }]},
            ]"
            placeholder="Select a session"
          >
            <a-select-option
              v-for="session in sessions"
              :key="session.id"
              :value="session.id"
            >
              {{ session.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Start Date" class="col-md-6">
          <a-date-picker
            v-decorator="[
              'start_date',
              {rules: [{ required: true, message: 'Please input a start date' }]},
            ]"
            :format="dateFormat"
          />
        </a-form-item>
        <a-form-item label="End Date" class="col-md-6">
          <a-date-picker
            v-decorator="[
              'end_date',
              {rules: [{ required: true, message: 'Please input an end date' }]},
            ]"
            :format="dateFormat"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'EditTerm',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      dateFormat: 'DD-MM-YYYY',
      sessions: [],
      sessionsLoading: false,
      termId: null,
    }
  },
  mounted() {
    // Listen for the event to open the modal with a specific term ID
    this.$eventBus.$on('openSessionEditModal', this.showModal)
  },
  beforeDestroy() {
    // Clean up event listener to prevent memory leaks
    this.$eventBus.$off('openSessionEditModal', this.showModal)
  },
  methods: {
    moment,
    showModal(termId) {
      this.termId = termId
      this.visible = true
      this.getSessions()
      this.fetchTermData()
    },
    getSessions() {
      this.sessionsLoading = true
      this.$http.get('/api/session').then(({ data }) => {
        this.sessions = data.data
        this.sessionsLoading = false
      }).catch(error => {
        this.sessionsLoading = false
        this.$neoNotify.error(error)
      })
    },
    fetchTermData() {
      this.$http.get(`/api/lesson-plan/academic-terms/${this.termId}`)
        .then(({ data }) => {
          const term = data

          // Set form fields with the fetched data
          this.form.setFieldsValue({
            name: term.name,
            session_id: term.session_id,
            start_date: moment(term.start_date),
            end_date: moment(term.end_date),
          })
        })
        .catch(error => {
          this.$neoNotify.error(error)
          this.visible = false
        })
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to update this term!`,
            onOk: () => {
              this.$http
                .put(`/api/lesson-plan/academic-terms/${this.termId}`, {
                  name: values.name,
                  session_id: values.session_id,
                  start_date: moment(values.start_date).format('YYYY-MM-DD'),
                  end_date: moment(values.end_date).format('YYYY-MM-DD'),
                })
                .then(({ data }) => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Term successfully updated',
                    description: `${data.name} updated successfully!`,
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        } else {
          this.loading = false
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleAfterClose() {
      // Reset form when modal is completely closed
      this.form.resetFields()
      this.termId = null
    },
  },
}
</script>
